import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import PostcodeAutocomplete from '../../legacy/hui/src/js/components/autocomplete/postcode-autocomplete';
import { ErrorText, StyledLabel } from './Field';
import { colors } from '../../legacy/hui/src/styled/theme';
import { Field } from 'redux-form';

const InputComponent = ({ input, meta, label, ...rest }) => (
  <div style={{ position: 'relative' }}>
    <PostcodeAutocomplete {...input} {...rest} />
    <StyledLabel>{label}</StyledLabel>
    {meta.error && <ErrorText className="error">{meta.error}</ErrorText>}
  </div>
);

InputComponent.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  label: PropTypes.string
};

const Autocomplete = ({ className, ...rest }) => (
  <div className={className}>
    <Field component={InputComponent} classPrefix={className} {...rest} />
  </div>
);

Autocomplete.propTypes = {
  className: PropTypes.string.isRequired,
  input: PropTypes.object,
  meta: PropTypes.object
};

const Styled = styled(Autocomplete)`
  width: 100%;

  &__suggestions-container {
    display: none;
  }

  &__container--open &__suggestions-container {
    color: #434447;
    top: calc(100% - 1px);
    text-align: left;
    border-radius: 4px;
    display: block;
    width: 100%;
    position: absolute;
    z-index: 10000;
    background: #fff;
    border: 1px solid ${colors.GREY};
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  &__input {
    width: 100%;
    font-size: 16px;
    border: 0;
    border-radius: 4px;
    appearance: none;
    outline: 0;
    border: 1px solid ${colors.GREY};
    position: relative;
    padding: 11px 20px;
    &::placeholder {
      color: ${colors.GREY};
    }
  }

  &__container--open &__input {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &__container--open &__suggestions-container {
    display: block;
  }

  &__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;

    li {
      font-size: 14px;
    }
  }

  &__suggestion {
    cursor: pointer;
    padding: 10px 20px;
    margin: 2px;
  }

  &__suggestion--focused {
    background-color: #eee;
    border-radius: 2px;
  }
`;

Styled.displayName = `SuburbSelect`;

export default Styled;
